import type * as React from 'react';

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { css, html } from 'react-strict-dom';
import { Text } from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';

type Props = {
  title: string;
  count?: number;
  collapsible?: boolean;
  children: React.ReactNode;
};

export default function DashboardSection({
  title,
  count,
  collapsible,
  children,
}: Props) {
  const [open, setOpen] = useState(true);
  const Caret = open ? CaretUpIcon : CaretDownIcon;

  return (
    <html.div style={styles.section}>
      <html.div
        style={[
          Style.row,
          Style.alignCenter,
          styles.header,
          collapsible && styles.headerClickable,
        ]}
        onClick={collapsible ? () => setOpen(!open) : undefined}
      >
        <Text typeface="body.medium" color="neutral100" as="h2" noSelect>
          {title}
        </Text>
        {count !== undefined && (
          <html.span style={styles.count}>
            <Text typeface="caption.semiBold" color="neutral80" noSelect>
              {count}
            </Text>
          </html.span>
        )}
        <html.span style={Style.fill} />
        {collapsible && <Caret size={16} color={Color.neutral60} />}
      </html.div>
      {open && children}
    </html.div>
  );
}

const styles = css.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  header: {
    gap: 8,
  },
  headerClickable: {
    cursor: 'pointer',
  },
  count: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 100,
    backgroundColor: color.neutral10,
    paddingInline: 8,
    paddingBlock: 2,
  },
});
